<template>
  <section>
    <el-form :model="formObj" label-width="120px" :rules="fromRules" ref="formObj">
      <div class="title"><i></i>整改单基本信息</div>
      <el-form-item label="项目" prop="proId">
        <el-select v-model="formObj.proId" placeholder="请选择项目" @change="proChange">
          <el-option v-for="(item,index) in GLOBAL.proList" :key="item.id" :value="item.id"
                     :label="item.proName"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="整改单名称" prop="rectifyName">
        <el-input v-model="formObj.rectifyName" auto-complete="off" maxlength="20" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="分部工程" prop="rectifySortPro">
        <el-select v-model="formObj.rectifySortPro" placeholder="请选择分部工程">
          <el-option :label="item.name" :value="item.id" :key="item.id"
                     v-for="(item,index) in sortProjects"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="选择专业" prop="rectifySpecial" v-if="type == 2">
        <el-select v-model="formObj.rectifySpecial" placeholder="请选择专业" @change="specialChange">
          <el-option :label="item.name" :value="item.id" :key="item.id" v-for="(item,index) in specials"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="问题类型" prop="rectifyQueType">
        <el-select v-model="formObj.rectifyQueType" placeholder="请选择问题类型">
          <el-option :label="item.name" :value="item.id" :key="item.id" v-for="(item,index) in questions"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="整改期限" prop="rectifyDate">
        <el-date-picker type="datetime" placeholder="选择日期" v-model="formObj.rectifyDate"></el-date-picker>
      </el-form-item>

      <el-form-item label="检查员" prop="rectifyCheckUser">
        <el-select v-model="formObj.rectifyCheckUser" placeholder="检查员">
          <el-option v-for="(item,index) in checkUsers" :key="item.id" :label="item.employeeName"
                     :value="item.id"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="责任施工员" prop="rectifyConUser">
        <el-select v-model="formObj.rectifyConUser" placeholder="施工员">
          <el-option v-for="(item,index) in conUsers" :key="item.id" :label="item.employeeName"
                     :value="item.id"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="责任人" prop="acceptUser">
        <work-team-list :team-list="teamList" :team-id="formObj.acceptUser" :team-label="acceptUserN"></work-team-list>
      </el-form-item>

      <div class="title"><i></i>问题描述</div>
      <el-form-item label="问题描述" prop="rectifyDesc">
        <el-input type="textarea" v-model="formObj.rectifyDesc" maxlength="300" show-word-limit></el-input>
      </el-form-item>
      <div class="title"><i></i>整改措施</div>
      <el-form-item label="整改措施" prop="rectifyMeasure">
        <el-input type="textarea" v-model="formObj.rectifyMeasure"></el-input>
      </el-form-item>
      <el-form-item label="添加照片">
        <el-upload
          :action="this.GLOBAL.baseServerPath+'/imgupload'"
          :headers="this.GLOBAL.fileHeader"
          name="file"
          list-type="picture-card"
          :limit="3"
          :on-exceed="handleExceed"
          :on-remove="fileRemove"
          :on-success="fileSuccess"
          :file-list="fileList">
          <div class="pic_btn"><i class="el-icon-plus"></i></div>
        </el-upload>
      </el-form-item>
    </el-form>
    <div class="dialog-footer">
      <el-button @click.native="doCancel">取消</el-button>
      <el-button type="primary" @click.native="doSubmit(option)">确定</el-button>
    </div>
  </section>
</template>

<script>
  import {dataList, tagRoles, workers, rectifyCreate, rectifyUpdate, proSearch} from '../../api/api'
  import WorkTeamList from "../command/WorkTeamList";

  export default {
    name: "RectifyForm",
    components: {WorkTeamList},
    props: {
      option: 0,
      formData: {},
      type: 0
    },
    data() {
      return {
        formObj: {proId: null, rectifyCheckUser: null, rectifyConUser: null, acceptUser: []},
        fromRules: {
          proId: [
            {required: true, message: '请选择项目', trigger: 'change'}
          ],
          rectifyName: [
            {required: true, message: '请输入整改单名称', trigger: 'blur'}
          ],
          rectifySortPro: [
            {required: true, message: '请选择分部工程', trigger: 'change'}
          ],
          rectifySpecial: [
            {required: true, message: '请选择专业', trigger: 'change'}
          ],
          rectifyQueType: [
            {required: true, message: '请选择问题类型', trigger: 'change'}
          ],
          rectifyDate: [
            {required: true, message: '请输入整改期限', trigger: 'change'}
          ],
          rectifyCheckUser: [
            {required: true, message: '请选择检查人员', trigger: 'change'}
          ],
          rectifyConUser: [
            {required: true, message: '请选择责任施工人员', trigger: 'change'}
          ],
          acceptUser: [
            {type: 'array', required: true, message: '请至少选择一个责任人', trigger: 'change'}
          ],
          rectifyDesc: [
            {required: true, message: '请输入问题描述', trigger: 'blur'}
          ],
          rectifyMeasure: [
            {required: true, message: '请输入整改措施', trigger: 'blur'}
          ]
        },
        fileList: [],
        sortProjects: [],//分部工程列表
        specials: [],//专业列表
        questions: [],//问题列表
        checkUsers: [],//检查人员列表
        conUsers: [],//施工人员列表
        projects: [],
        teamList: [],//责任人
        acceptUserN: [],
        acceptUser: [],
        imgList: [],
        proList: [],
      }
    },
    methods: {
      doSubmit: function (option) {

        this.$refs.formObj.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {type: 'warning'}).then(() => {
              this.formObj.rectifyDutyUser = this.formObj.acceptUser.join(",");
              this.formObj.rectifyDutyUserN = this.acceptUserN.join(",");
              this.formObj.rectifyPhoto = this.imgList.join(',');

              if (option == 0) {
                this.formObj.rectifyType = this.type;
                rectifyCreate(this.formObj, this.GLOBAL.header).then(result => {
                  if (result.success) {
                    this.$message({
                      message: "添加成功",
                      type: 'success'
                    });
                    this.$emit('doSubmit');
                  }
                });
              } else if (option == 1) {
                rectifyUpdate(this.formObj, this.GLOBAL.header).then(result => {
                  if (result.success) {
                    this.$message({
                      message: "修改成功",
                      type: 'success'
                    });
                    this.$emit('doSubmit');
                  }
                });
              }
            }).catch(() => {
            });
          }
        });
      },
      doCancel: function () {
        this.$emit('doCancel');
      },
      //删除上传图片
      fileRemove(file, fileList) {
        if (this.option == 0) {
          let n = this.imgList.indexOf(file.response.data);
          if (n > -1) {
            this.imgList.splice(n, 1);
          }
        } else {
          let index = file.url.lastIndexOf("/");
          file.url = file.url.substring(index - 9, file.url.length);
          let n = this.imgList.indexOf(file.url);
          let m = this.fileList.indexOf(file);
          if (n > -1) {
            this.imgList.splice(n, 1);
          }
          if (m > -1) {
            this.fileList.splice(m, 1);
          }
        }
      },
      //图片上传成功
      fileSuccess(response, file, fileList) {
        this.imgList.push(response.data);
      },
      //上传限制
      handleExceed: function (files, fileList) {
        this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      //专业改变事件 获取对应的问题列表
      specialChange: function (id) {
        dataList({key: this.GLOBAL.command.question, status: id}, this.GLOBAL.header).then(result => {
          if (result.success) {
            this.questions = result.data
          }
        });
      },
      proChange: function () {
        //如果是质量获取质量员列表 如果是安全 获取安全员列表
        let tagKey = null;
        if (this.type == this.GLOBAL.qualityType) {
          tagKey = this.GLOBAL.roleTag.quality
        } else {
          tagKey = this.GLOBAL.roleTag.safer;
        }
        if (this.formObj.proId != null) {
          //检查员
          workers({
            key: tagKey,
            comId: this.GLOBAL.user.comId,
            proId: this.formObj.proId
          }, this.GLOBAL.header).then(result => {
            if (result.success) {
              this.checkUsers = [];
              this.checkUsers = result.data;

              if(this.option == 0){
                if (this.GLOBAL.user.id==1) {
                  this.checkUsers.push({id: this.GLOBAL.user.id, employeeName: this.GLOBAL.user.employeeName});
                }
                this.formObj.rectifyCheckUser = this.GLOBAL.user.id;
              }
              if (this.option == 1 && this.checkUsers.length > 0) {
                if(this.formObj.rectifyCheckUser==1 || this.GLOBAL.user.id==1){
                  this.checkUsers.push({id: 1, employeeName: '平台管理员'});
                }
                this.formObj.rectifyCheckUser = parseInt(this.formObj.rectifyCheckUser);
              }
            }
          });
          //施工员
          workers({
            key: this.GLOBAL.roleTag.construction,
            comId: this.GLOBAL.user.comId,
            proId: this.formObj.proId
          }, this.GLOBAL.header).then(result => {
            if (result.success) {
              this.conUsers = [];
              this.conUsers = result.data;
              if (this.option == 1 && this.conUsers.length > 0) {
                this.formObj.rectifyConUser = parseInt(this.formObj.rectifyConUser);
              }
            }
          });
          //指定岗位标记下的岗位集合
          tagRoles({
            key: this.GLOBAL.roleTag.workTeam,
            comId: this.GLOBAL.user.comId,
            proId: this.formObj.proId
          }, this.GLOBAL.header).then(result => {
            if (result.success) {
              this.acceptUserN = [];
              this.teamList = [];
              this.teamList = result.data;
              if (this.option == 1 && this.teamList.length > 0) {
                this.formObj.acceptUser = this.formObj.rectifyDutyUser.split(',');
                this.acceptUserN = this.formObj.rectifyDutyUserN.split(',');
              }
            }
          });
        }
      }
    },
    mounted() {
      //初始化表单数据
      this.formObj = this.formData;
      //加载数据=================================================================
      //分部工程/分项列表
      dataList({key: this.GLOBAL.command.sortProject}, this.GLOBAL.header).then(result => {
        if (result.success) {
          this.sortProjects = result.data
        }
      });
      //专业
      dataList({key: this.GLOBAL.command.special, status: -this.type}, this.GLOBAL.header).then(result => {
        if (result.success) {
          this.specials = result.data
        }
      });
      if (this.type == 1 && this.option == 0) {
        dataList({key: this.GLOBAL.command.question, status: 20}, this.GLOBAL.header).then(result => {
          if (result.success) {
            this.questions = result.data
          }
        });
      }
      if (this.option == 1) {
        let qstatus = 20;
        if (this.type == 2) {
          qstatus = this.formObj.rectifySpecial;
        }
        dataList({key: this.GLOBAL.command.question, status: qstatus}, this.GLOBAL.header).then(result => {
          if (result.success) {
            this.questions = result.data
          }
        });
        if (this.formObj.rectifyPhoto != null) {
          this.imgList = this.formObj.rectifyPhoto.split(',');
          for (let i = 0; i < this.imgList.length; i++) {
            if (this.imgList[i] != "") {
              this.fileList.push({url: this.GLOBAL.basePhotoPath + "" + this.imgList[i]})
            }
          }
        }
      }
      this.proChange();
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/rectify/RectifyForm.vue